import i18n from 'src/i18n'
import clsx from 'clsx'
import { useDecision } from '@optimizely/react-sdk'
import { Wrapper } from './moderationTag.styles'
import { ModerationTagProps } from './moderationTag.types'

const ModerationTag = ({ className }: ModerationTagProps) => {
  const [tagModerationFeatureFlag] = useDecision('com_eng_web_enable_tag_moderation')

  if (!tagModerationFeatureFlag.enabled) {
    return null
  }

  return (
    <Wrapper
      className={clsx(
        className,
        '_rounded _border _border-gray-400 _d-inline-flex _justify-content-center _align-items-center _text-center _bg-gray-200 _text-1 _text-gray-700 _font-weight-bold _px-2'
      )}
    >
      {i18n.t('buttons.moderation')}
    </Wrapper>
  )
}

export default ModerationTag
